<template lang="pug">
.forminput-resident-status-radio.register-row
  .register-group
    .register-value
      label.register-radio-label(v-for="(option, index) in options")
        // first input
        .radio(v-if="index == 0")
          input.register-radio-form(v-model="_value" type="radio" :name="name" :value="option.value"
            v-validate="validationRules" :data-vv-as="(validationKeyName) ? validationKeyName : keyName")
          span.register-radio-text {{ option.label }}
        // other input
        .radio(v-else)
          input.register-radio-form(v-model="_value" type="radio" :name="name" :value="option.value")
          span.register-radio-text {{ option.label }}

      .error-messages(v-for="error in errors.collect(name)")
        label.error-message {{ error }}
        br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputResidentStatusRadio extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string | number;

  /** リスト項目 */
  @Prop()
  options!: Array<{ value: number | string; label: string }>;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** 説明文 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  optionText!: string;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string | number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string | number) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.forminput-resident-status-radio.register-row {
  margin-bottom: 0 !important;

  .register-group {
    margin: 0 4px 0 4px !important;

    .register-value {
      display: flex;
      flex-direction: column !important;
      align-items: stretch;

      .register-radio-label {
        margin: 0 4px 4px 0;
      }

      .register-radio-text {
        display: inline-block;
        margin: 0;
        padding: 4px 6px;
        @include font(14px);
        border-radius: 3px;
        transition: all 0.2s;
        border: 1px solid $form-border-color;
        background-color: $bg-default;
        cursor: pointer;

        &:hover {
          background: $list-hover;
        }
      }
      .register-radio-text.disable {
        display: inline-block;
        margin: 0;
        cursor: not-allowed !important;
        color: $btn-font-disable !important;

        &:hover {
          background: $bg-default !important;
        }
      }
    }
  }
}
</style>
